/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ActivateExternalReceiptAccountRequestDto,
  Base64ImageDto,
  CreateExpenseRequest,
  ExpenseResponse,
  ExternalReceiptAccountAvailabilityRequestDto,
  ExternalReceiptAccountAvailabilityResponseDto,
  ExternalReceiptAccountDto,
  ExternalReceiptAccountResponseDto,
  ExternalReceiptFeedbackRequestDto,
  FileDescriptorResponse,
  UpdateReceiptValidity,
  UploadExpenseFileBody,
  UploadExpenseFileParams1,
  UploadExpenseFileWithFlowIdPayload,
  UploadExpenseFilesWithFlowIdPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiExpenseController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-expense-controller
   * @name UpdateFileReceiptValidity
   * @request PUT:/api/v1/expenses/{expenseId}/file/{fileId}/validity
   */
  updateFileReceiptValidity = (
    expenseId: string,
    fileId: string,
    data: UpdateReceiptValidity,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}/validity`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateFileReceiptValidityPath = '/v1/expenses/${expenseId}/file/${fileId}/validity'
  static updateFileReceiptValidityMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name CreateExpense
   * @request POST:/api/v1/expenses
   */
  createExpense = (data: CreateExpenseRequest, params: RequestParams = {}) =>
    this.http.request<ExpenseResponse, any>({
      path: `/v1/expenses`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createExpensePath = '/v1/expenses'
  static createExpenseMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name UploadExpenseFileWithFlowId
   * @request POST:/api/v1/expenses/flow-id/{flowId}/file
   */
  uploadExpenseFileWithFlowId = (
    flowId: string,
    data: UploadExpenseFileWithFlowIdPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FileDescriptorResponse, any>({
      path: `/v1/expenses/flow-id/${flowId}/file`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadExpenseFileWithFlowIdPath = '/v1/expenses/flow-id/${flowId}/file'
  static uploadExpenseFileWithFlowIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name UploadExpenseFilesWithFlowId
   * @request POST:/api/v1/expenses/flow-id/{flowId}/file/batch
   */
  uploadExpenseFilesWithFlowId = (
    flowId: string,
    data: UploadExpenseFilesWithFlowIdPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<FileDescriptorResponse[], any>({
      path: `/v1/expenses/flow-id/${flowId}/file/batch`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadExpenseFilesWithFlowIdPath = '/v1/expenses/flow-id/${flowId}/file/batch'
  static uploadExpenseFilesWithFlowIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name UploadExpenseFile
   * @request POST:/api/v1/expenses/file
   */
  uploadExpenseFile = (
    query: UploadExpenseFileParams1,
    data: UploadExpenseFileBody,
    params: RequestParams = {},
  ) =>
    this.http.request<FileDescriptorResponse, any>({
      path: `/v1/expenses/file`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static uploadExpenseFilePath = '/v1/expenses/file'
  static uploadExpenseFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name SubmitFeedback
   * @request POST:/api/v1/expenses/external-receipts/feedback
   */
  submitFeedback = (data: ExternalReceiptFeedbackRequestDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expenses/external-receipts/feedback`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static submitFeedbackPath = '/v1/expenses/external-receipts/feedback'
  static submitFeedbackMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name CheckAvailability
   * @request POST:/api/v1/expenses/external-receipts/account/available
   */
  checkAvailability = (
    data: ExternalReceiptAccountAvailabilityRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ExternalReceiptAccountAvailabilityResponseDto, any>({
      path: `/v1/expenses/external-receipts/account/available`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static checkAvailabilityPath = '/v1/expenses/external-receipts/account/available'
  static checkAvailabilityMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name ActivateReceiptInboxAccount
   * @request POST:/api/v1/expenses/external-receipts/account/activate
   */
  activateReceiptInboxAccount = (
    data: ActivateExternalReceiptAccountRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/expenses/external-receipts/account/activate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static activateReceiptInboxAccountPath = '/v1/expenses/external-receipts/account/activate'
  static activateReceiptInboxAccountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetExpenseById
   * @request GET:/api/v1/expenses/{expenseId}
   */
  getExpenseById = (expenseId: string, params: RequestParams = {}) =>
    this.http.request<ExpenseResponse, any>({
      path: `/v1/expenses/${expenseId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getExpenseByIdPath = '/v1/expenses/${expenseId}'
  static getExpenseByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetThumbnailsList
   * @request GET:/api/v1/expenses/{expenseId}/thumbnails
   */
  getThumbnailsList = (expenseId: string, params: RequestParams = {}) =>
    this.http.request<Base64ImageDto[], any>({
      path: `/v1/expenses/${expenseId}/thumbnails`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getThumbnailsListPath = '/v1/expenses/${expenseId}/thumbnails'
  static getThumbnailsListMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name DownloadFile
   * @request GET:/api/v1/expenses/{expenseId}/file/{fileId}
   */
  downloadFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}`,
      method: 'GET',
      ...params,
    })

  static downloadFilePath = '/v1/expenses/${expenseId}/file/${fileId}'
  static downloadFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name DeleteFile
   * @request DELETE:/api/v1/expenses/{expenseId}/file/{fileId}
   */
  deleteFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteFilePath = '/v1/expenses/${expenseId}/file/${fileId}'
  static deleteFileMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name DownloadFileThumbnail
   * @request GET:/api/v1/expenses/{expenseId}/file/{fileId}/thumbnail
   */
  downloadFileThumbnail = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}/thumbnail`,
      method: 'GET',
      ...params,
    })

  static downloadFileThumbnailPath = '/v1/expenses/${expenseId}/file/${fileId}/thumbnail'
  static downloadFileThumbnailMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name DownloadFileRaw
   * @request GET:/api/v1/expenses/{expenseId}/file/{fileId}/raw
   */
  downloadFileRaw = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}/raw`,
      method: 'GET',
      ...params,
    })

  static downloadFileRawPath = '/v1/expenses/${expenseId}/file/${fileId}/raw'
  static downloadFileRawMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetImageFile
   * @request GET:/api/v1/expenses/{expenseId}/file/{fileId}/image
   */
  getImageFile = (expenseId: string, fileId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/expenses/${expenseId}/file/${fileId}/image`,
      method: 'GET',
      format: 'blob',
      ...params,
    })

  static getImageFilePath = '/v1/expenses/${expenseId}/file/${fileId}/image'
  static getImageFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetExpenseByCardTransactionId
   * @request GET:/api/v1/expenses/flow-id/{flowId}
   */
  getExpenseByCardTransactionId = (flowId: string, params: RequestParams = {}) =>
    this.http.request<ExpenseResponse, any>({
      path: `/v1/expenses/flow-id/${flowId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getExpenseByCardTransactionIdPath = '/v1/expenses/flow-id/${flowId}'
  static getExpenseByCardTransactionIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetExternalReceiptAccount
   * @request GET:/api/v1/expenses/external-receipts/account
   */
  getExternalReceiptAccount = (params: RequestParams = {}) =>
    this.http.request<ExternalReceiptAccountDto, any>({
      path: `/v1/expenses/external-receipts/account`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getExternalReceiptAccountPath = '/v1/expenses/external-receipts/account'
  static getExternalReceiptAccountMethod = 'GET'
  /**
   * No description
   *
   * @tags api-expense-controller
   * @name GetRecommendedReceiptInboxAccountName
   * @request GET:/api/v1/expenses/external-receipts/account/unactivated
   */
  getRecommendedReceiptInboxAccountName = (params: RequestParams = {}) =>
    this.http.request<ExternalReceiptAccountResponseDto, any>({
      path: `/v1/expenses/external-receipts/account/unactivated`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getRecommendedReceiptInboxAccountNamePath =
    '/v1/expenses/external-receipts/account/unactivated'
  static getRecommendedReceiptInboxAccountNameMethod = 'GET'
}
